module.exports = require('./_hide');



//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs2/~/core-js/library/modules/_redefine.js
// module id = C0jx
// module chunks = 0